export default __webpack_public_path__ + "static/media/truffle_thumb.311f5427.jpg";